<template>
  <v-container
    id="contact-list"
    fluid
    tag="section"
  >
    <filter-form :filter-form="filterForm" />
    <contact-source-table
      :contacts="contacts"
    />
    <common-no-result
      v-if="!loading && totalItem === 0"
    />
    <!-- <common-no-result/> -->
    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      />
      <v-col
        cols="12"
        sm="6"
      >
        <v-pagination
          v-if="totalItem > limit"
          v-model="currentPage"
          :length="getTotalItem(totalItem)"
          class="justify-sm-end"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import FilterForm from './components/FilterForm'
  import ContactSourceTable from './components/ContactSourceTable'
  import RepositoryFactory from '../../repositories/RepositoryFactory'
  const ContactSourceRepository = RepositoryFactory.get('contact_source')
  export default {
    components: { FilterForm, ContactSourceTable },
    data () {
      return {
        filterForm: {},
        currentPage: 1,
        limit: 10,
        totalItem: 0,
        contacts: [],
        loading: false,
      }
    },
    watch: {
      currentPage: {
        handler () {
          this.getContactList()
        },
      },
      limit: {
        handler () {
          if (this.currentPage === 1) {
            this.getContactList()
          } else {
            this.currentPage = 1
          }
        },
      },
    },
    created () {
      this.getContactList()
      Bus.$on('contact-source-list-filter', (filterForm) => {
        this.filterForm = filterForm
        this.currentPage = 1
        this.getContactList()
      })
      Bus.$on('contact-source-list-reload', () => {
        this.getContactList()
      })
    },
    beforeDestroy () {
      Bus.$off('contact-source-list-filter')
    },
    methods: {
      async getContactList () {
        const params = {
          limit: this.limit,
          page: this.currentPage - 1,
          keyword: this.filterForm.keyword,
          status: this.filterForm.status,
        }
        const loader = this.$loading.show()
        const response = await ContactSourceRepository.list(params)
        loader.hide()
        if (response.success) {
          this.contacts = _.get(response, 'data', [])
          this.totalItem = response.totalItem
        }
      },
    },
  }
</script>
